<template>
  <div class="box">
    <div class="wrap-form" v-if="loaded">
      <a-form :form="form" class="form">
        <div class="step-hint-bar">
          <div class="step-hint-left">
            <span class="hand-icon">👋</span>
            <div class="step-hint-text">
              <div class="step-hint-title">
                {{ $t("StepHintTitle") }}
              </div>
              <div class="step-hint-desc">
                {{ $t("StepHintDesc") }}
              </div>
            </div>
          </div>
          <a-button class="pro-hint-btn" :class="{ 'minimized-btn': !showTipsInfo }" shape="round" size="small"
            @click="$emit('toggleIntro', !showTipsInfo)">
            {{
              showTipsInfo
                ? $t("ProHintBtnShow")
                : $t("ProHintBtnHide")
            }}
          </a-button>
        </div>
        <div id="campaign-create-name">
          <div :class="[lang]">
            <div class="tit" :class="[lang]" style="width: 500px; display: inline-block">
              <svg-icon iconClass="search" class="tit-icon"></svg-icon><span>{{ $t("capaginName") }}</span>
            </div>
          </div>

          <div :class="[lang]">
            <a-form-item :class="[lang]">
              <a-input size="large" ref="campaign_name" :maxLength="30" :disabled="inputDisabled" v-decorator="[
                'campaign_name',
                {
                  initialValue: campName,
                  rules: [
                    {
                      trim: true,
                      required: true,
                      validator: async function (rule, value, callback) {
                        if (!value || !value.trim('')) {
                          callback($t('Pleaseenterthecampaignname'));
                          return;
                        }
                        // 添加逻辑校验是否存在调接口
                        let res = await isCampaignNameLegal(value);
                        if (!res.reslut) {
                          callback(res.msg);
                          return;
                        }
                        callback();
                      },
                      trigger: 'blur',
                    },
                  ],
                  trigger: 'blur',
                },
              ]" :placeholder="$t('Pleaseenterthecampaignname')" />
              <div class="input-tip" v-show="showTipsInfo">
                <span class="input-tip-icon">💡</span>
                <span class="input-tip-text" v-html="$t('CampaignNameTipText')">
                </span>
              </div>
            </a-form-item>
          </div>
        </div>
        <div id="campaign-create-linkin">
          <div :class="[lang]">
            <div class="tit" :class="[lang]" style="width: 500px; display: inline-block">
              <svg-icon iconClass="bind" class="tit-icon"></svg-icon><span :class="[lang]">{{ $t("bindLinkAcc")
              }}</span>
              <a-popover :placement="lang == 'AR' ? 'bottomRight' : 'bottomLeft'" style="z-index: 98" trigger="click"
                v-model="visiable">
                <template slot="content">
                  <div class="popbox">
                    <p class="main-tit" :class="[lang]" :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }">
                      {{ $t("bindLinkAccTipTitle1") }}
                    </p>
                    <div class="ptit" :class="[lang]" :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }">
                      <span :class="[lang]">{{
                        $t("bindLinkAccTipcon1")
                      }}</span>
                    </div>

                    <p class="main-tit main-tit2" :class="[lang]" :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }">
                      {{ $t("bindLinkAccTipTitle2") }}
                    </p>
                    <div class="ptit" :class="[lang]" :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }">
                      <div :class="[lang]" class="txt-red" :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }">
                        {{ $t("bindLinkAccTipcon2") }}
                      </div>
                      <div :class="[lang]" class="txt-red" :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }">
                        {{ $t("bindLinkAccTipcon3") }}
                      </div>
                    </div>
                    <div class="btn-box" :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }">
                      <span :class="[lang]" class="btn-txt" @click="goLink">{{
                        $t("bindLinkAccTipBtn")
                      }}</span><span :class="[lang]">{{
                          $t("bindLinkAccTipBtnTxt")
                        }}</span>
                    </div>
                  </div>
                </template>

                <a-icon type="question-circle" style="
                    font-size: 14px;
                    color: #0e756a;
                    cursor: pointer;
                    margin-left: 6px;
                  " />
              </a-popover>
            </div>
          </div>
          <div class="safe-card">
            <div class="safe-card-header" @click="safeCardExpanded = !safeCardExpanded">
              <span><span class="shield-icon">️</span> {{ $t("SafeCardHeader") }}</span>
              <a-icon :type="safeCardExpanded ? 'up' : 'down'" />
            </div>
            <div v-show="safeCardExpanded" class="safe-card-body">
              <div class="safe-intro">
                {{ $t("SafeCardIntro") }}
              </div>
              <div class="safe-grid">
                <div class="safe-item">
                  <span class="safe-item-icon">🌐</span>
                  <div class="safe-item-text">
                    <div class="safe-item-title">{{ $t("SafeItemProxyTitle") }}</div>
                    <div class="safe-item-desc">
                      {{ $t("SafeItemProxyDesc") }}
                    </div>
                  </div>
                </div>
                <div class="safe-item">
                  <span class="safe-item-icon">🐢</span>
                  <div class="safe-item-text">
                    <div class="safe-item-title">{{ $t("SafeItemRateTitle") }}</div>
                    <div class="safe-item-desc">
                      {{ $t("SafeItemRateDesc") }}
                    </div>
                  </div>
                </div>
                <div class="safe-item">
                  <span class="safe-item-icon">🔒</span>
                  <div class="safe-item-text">
                    <div class="safe-item-title">{{ $t("SafeItemEncryptTitle") }}</div>
                    <div class="safe-item-desc">
                      {{ $t("SafeItemEncryptDesc") }}
                    </div>
                  </div>
                </div>
                <div class="safe-item">
                  <span class="safe-item-icon">🔓</span>
                  <div class="safe-item-text">
                    <div class="safe-item-title">{{ $t("SafeItemDisconnectTitle") }}</div>
                    <div class="safe-item-desc">
                      {{ $t("SafeItemDisconnectDesc") }}
                    </div>
                  </div>
                </div>
              </div>
              <a class="learn-more" target="_blank" href="https://leadgeneration.tawk.help/article/linkedin-usage-restrictions-and-settings">{{ $t("LearnMoreLink") }}</a>
            </div>
          </div>
          <div class="showInfo" v-if="
            (detailObj.linkedin_id || (this.firstReg && new_linkedin_id)) &&
            $route.query.edit != 3
          ">
            <ul>
              <li>
                <div class="lc" :class="[lang]">
                  <svg-icon iconClass="email" class="l-icon"></svg-icon>
                  <span class="t1" :class="[lang]">
                    {{ $t("Account") }}：
                  </span>
                  <span class="t2" :class="[lang]">{{
                    detailObj.linkedin_email
                      ? detailObj.linkedin_email
                      : formData.linkedin_email
                  }}</span>
                </div>
              </li>
              <li v-if="detailObj.time_zone || formData.timezone_config_id">
                <div class="lc" :class="[lang]">
                  <svg-icon iconClass="timezone" class="l-icon"></svg-icon>
                  <span class="t1" :class="[lang]">
                    {{ $t("TimeZone") }}：
                  </span>
                  <span class="t2" :class="[lang]">{{
                    detailObj.time_zone
                      ? getTimez(detailObj.time_zone)
                      : getTimez(formData.timezone_config_id)
                  }}</span>
                </div>
                <div class="rc">
                  <svg-icon iconClass="right" class="r-icon"></svg-icon>
                  {{ $t("Connected") }}
                </div>
              </li>
              <li v-if="detailObj.proxy_manually || formData.country_config_id">
                <div class="lc" :class="[lang]">
                  <svg-icon iconClass="global" class="l-icon"></svg-icon>
                  <span class="t1" :class="[lang]"> {{ $t("Proxy") }}： </span>
                  <span class="t2" :class="[lang]">{{
                    detailObj.proxy_settings
                      ? getcountry(detailObj.proxy_settings)
                      : getcountry(formData.country_config_id)
                  }}</span>
                </div>
              </li>
              <li style="margin-bottom: 0">
                <div class="lc" :class="[lang]">
                  <a-icon type="schedule" style="color: #0e756a" class="l-icon" />
                  <span class="t1" :class="[lang]">
                    {{ $t("LinkedinAvailabilitySchedule") }}：
                  </span>
                  <span class="t2" :class="[lang]">{{
                    detailObj.working_time == 1
                      ? $t("BusinessHoursMS")
                      : detailObj.working_time == 2
                        ? $t("BusinessHoursMF")
                        : $t("AlwaysOn")
                  }}</span>
                </div>
              </li>
            </ul>
          </div>
          <!--编辑-->
          <div class="wrap-link-list" v-if="(!firstReg && !$route.query.edit) || $route.query.edit == 3">
            <a-form-item :class="[lang]">
              <a-radio-group v-decorator="[
                'link_id',
                {
                  initialValue: default_link_id,
                  rules: [
                    {
                      required: true,
                      message: $t('inputLinkAccount'),
                    },
                  ],
                },
              ]" @change="selectedRadio">
                <ul>
                  <li v-for="(item, index) in linkList" :key="index">
                    <label style="width: 100%">
                      <div class="text">
                        <svg-icon iconClass="email" class="icon"></svg-icon>
                        {{ item.linkedin_email }}
                      </div>
                      <a-radio :value="item.linkedin_id"> </a-radio>
                    </label>
                  </li>
                </ul>
              </a-radio-group>
            </a-form-item>
            <!-- <div
              :class="[lang]"
              style="color: red; padding-bottom: 4px; font-size: 12px"
            >
              *1.<span v-html="$t('verifyyourLinkedIn')"></span>
            </div>
            <div
              :class="[lang]"
              style="color: red; padding-bottom: 16px; font-size: 12px"
            >
              *2.<span v-html="$t('Avoidswitchingaccounts')"></span>
            </div> -->
          </div>
        </div>

        <!-- 第一次绑定的过程中-->
        <template v-if="$route.query.linkedin_id == 'new' && processing && firstReg">
          <div class="processing">
            <div class="cstep">
              <div class="number" v-if="processStep.step1 == 0">1</div>
              <svg-icon v-if="processStep.step1 == 1" iconClass="wrong" class="cicon"></svg-icon>
              <svg-icon v-if="processStep.step1 == 2" iconClass="load" class="cicon rotating"></svg-icon>
              <svg-icon v-if="processStep.step1 == 3" iconClass="right" class="cicon"></svg-icon>
              <div class="text" :class="{
                wrong: processStep.step1 == 1,
                right: processStep.step1 == 2 || processStep.step1 == 3,
              }">
                <span :class="[lang]">{{ $t("ObtainProxyIP") }}</span>
              </div>
            </div>
            <div class="splitbox getProxy">
              <div class="asset" v-if="processStep.step1 == 1">
                <a-form-item style="width: 316px; margin-bottom: 0" :class="[lang]">
                  <div class="wrap-select">
                    <svg-icon iconClass="global" class="prefix"></svg-icon>
                    <a-select size="large" class="process-input process-select" :filter-option="filterOption" showSearch
                      v-decorator="[
                        'country_config_id',
                        {
                          rules: [
                            {
                              required: true,
                              message: $t('selectRegion'),
                            },
                          ],
                        },
                      ]" :placeholder="$t('SelectProxyRegion')">
                      <a-select-option :class="[lang]" v-for="(item, index) in locationList" :key="index"
                        :value="item.id">
                        {{ item.show_name }}
                      </a-select-option>
                    </a-select>
                  </div>
                </a-form-item>
              </div>
            </div>
            <div class="cstep">
              <div class="number" v-if="processStep.step2 == 0">2</div>
              <svg-icon v-if="processStep.step2 == 1" iconClass="wrong" class="cicon"></svg-icon>
              <svg-icon v-if="processStep.step2 == 2" iconClass="load" class="cicon rotating"></svg-icon>
              <svg-icon v-if="processStep.step2 == 3" iconClass="right" class="cicon"></svg-icon>
              <div class="text" :class="{
                wrong: processStep.step2 == 1,
                right: processStep.step2 == 2 || processStep.step2 == 3,
              }">
                {{ $t("VerifyLink") }}
              </div>
            </div>
            <div class="splitbox getProxy">
              <div class="asset" v-if="processStep.step2 == 1">
                <a-form-item style="margin-bottom: 20px" :class="[lang]">
                  <a-input size="large" class="process-input" @change="changeHandler1" autocomplate="off" v-decorator="[
                    'linkedin_email',
                    {
                      trim: true,
                      rules: [
                        {
                          required: true,
                          validator: function (rule, value, callback) {
                            let reg =
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                            if (
                              !value ||
                              !value.trim('') ||
                              !reg.test(value)
                            ) {
                              callback($t('rightAccount'));
                              return;
                            }
                            callback();
                          },
                        },
                      ],
                    },
                  ]" :placeholder="$t('linkEmal')">
                    <svg-icon iconClass="email" slot="prefix"></svg-icon>
                  </a-input>
                </a-form-item>
                <a-form-item :class="[lang]">
                  <a-input-password size="large" class="process-input" type="linkedin_password"
                    oninput="value=value.trim()" onchange="value=value.trim()" @change="changePassword" v-decorator="[
                      'linkedin_password',
                      {
                        trim: true,
                        rules: [
                          {
                            required: true,
                            message: $t('inputPwd'),
                          },
                        ],
                      },
                    ]" :placeholder="$t('linkPwd')">
                    <svg-icon iconClass="lock" slot="prefix"></svg-icon>
                  </a-input-password>
                </a-form-item>
              </div>
            </div>
            <div class="cstep">
              <div class="number" v-if="processStep.step3 == 0">3</div>
              <svg-icon v-if="processStep.step3 == 1" iconClass="wrong" class="cicon"></svg-icon>
              <svg-icon v-if="processStep.step3 == 2" iconClass="load" class="cicon rotating"></svg-icon>
              <svg-icon v-if="processStep.step3 == 3" iconClass="right" class="cicon"></svg-icon>
              <div class="text" :class="{
                wrong: processStep.step3 == 1,
                right: processStep.step3 == 2 || processStep.step3 == 3,
              }">
                <span :class="[lang]">{{ $t("LinkedInAccountLink") }}</span>
              </div>
            </div>
            <div v-if="processStep.step3 == 1" class="splitbox getProxy" style="border-left: #fff solid 1px">
              <div class="asset">
                <!-- <div class="tips">
                  <a-icon
                    type="exclamation-circle"
                    style="margin-right: 12px; color: #ffa200"
                  />
                  <div>
                    <span :class="[lang]">{{ $t("bindTips") }}</span>
                  </div>
                </div> -->
                <div class="faCodeBox">
                  <div class="faCodeBox-title">
                    <span class="faCodeBox-title-icon">🔒</span>
                    <span>{{ $t("FaCodeBoxTitle") }}</span>
                  </div>
                  <p class="faCodeBox-desc" v-html="$t('FaCodeBoxDesc')">
                  </p>

                  <div class="faCodeBox-channels">
                    <!-- LinkedIn app push -->
                    <div class="faCodeBox-channel"
                      :class="{ primary: linkLoginInfo.action === 'confirm_in_linkedin_app' }">
                      <div class="faCodeBox-channel-head">
                        <div class="faCodeBox-channel-icon">📱</div>
                        <div class="faCodeBox-channel-text">
                          <div class="faCodeBox-channel-title">
                            {{ $t("FaCodeChannelAppTitle") }}
                          </div>
                          <div class="faCodeBox-channel-desc">
                            {{ $t("FaCodeChannelAppDesc") }}
                          </div>
                        </div>
                      </div>
                      <div class="faCodeBox-channel-shot" @click="viewLargerImg(faChannelImgs.app)">
                        <img :src="faChannelImgs.app" :alt="$t('FaCodeChannelAppTitle')" />
                      </div>
                      <a class="faCodeBox-channel-view" href="javascript:void(0)"
                        @click="viewLargerImg(faChannelImgs.app)">{{ $t("FaCodeViewLarger") }}</a>
                    </div>
                    <!-- Registered email -->
                    <div class="faCodeBox-channel" :class="{ primary: linkLoginInfo.channel === 'email' }">
                      <div class="faCodeBox-channel-head">
                        <div class="faCodeBox-channel-icon">✉️</div>
                        <div class="faCodeBox-channel-text">
                          <div class="faCodeBox-channel-title">
                            {{ $t("FaCodeChannelEmailTitle") }}
                          </div>
                          <div class="faCodeBox-channel-desc">
                            {{ $t("FaCodeChannelEmailDesc") }}
                          </div>
                        </div>
                      </div>
                      <div class="faCodeBox-channel-shot" @click="viewLargerImg(faChannelImgs.email)">
                        <img :src="faChannelImgs.email" :alt="$t('FaCodeChannelEmailTitle')" />
                      </div>
                      <a class="faCodeBox-channel-view" href="javascript:void(0)"
                        @click="viewLargerImg(faChannelImgs.email)">{{ $t("FaCodeViewLarger") }}</a>
                    </div>
                    <!-- Authenticator app -->
                    <div class="faCodeBox-channel" :class="{ primary: linkLoginInfo.channel === 'authenticator_app' }">
                      <div class="faCodeBox-channel-head">
                        <div class="faCodeBox-channel-icon">🔐</div>
                        <div class="faCodeBox-channel-text">
                          <div class="faCodeBox-channel-title">{{ $t("FaCodeChannelAuthTitle") }}</div>
                          <div class="faCodeBox-channel-desc">
                            {{ $t("FaCodeChannelAuthDesc") }}
                          </div>
                        </div>
                      </div>
                      <div class="faCodeBox-channel-shot" @click="viewLargerImg(faChannelImgs.auth)">
                        <img :src="faChannelImgs.auth" :alt="$t('FaCodeChannelAuthTitle')" />
                      </div>
                      <a class="faCodeBox-channel-view" href="javascript:void(0)"
                        @click="viewLargerImg(faChannelImgs.auth)">{{ $t("FaCodeViewLarger") }}</a>
                    </div>
                    <!-- SMS -->
                    <div class="faCodeBox-channel" :class="{ primary: linkLoginInfo.channel === 'phone' }">
                      <div class="faCodeBox-channel-head">
                        <div class="faCodeBox-channel-icon">💬</div>
                        <div class="faCodeBox-channel-text">
                          <div class="faCodeBox-channel-title">{{ $t("FaCodeChannelSmsTitle") }}</div>
                          <div class="faCodeBox-channel-desc">
                            {{ $t("FaCodeChannelSmsDesc") }}
                          </div>
                        </div>
                      </div>
                      <div class="faCodeBox-channel-shot" @click="viewLargerImg(faChannelImgs.sms)">
                        <img :src="faChannelImgs.sms" :alt="$t('FaCodeChannelSmsTitle')" />
                      </div>
                      <a class="faCodeBox-channel-view" href="javascript:void(0)"
                        @click="viewLargerImg(faChannelImgs.sms)">{{ $t("FaCodeViewLarger") }}</a>
                    </div>
                  </div>
                  <template v-if="linkLoginInfo.action !== 'confirm_in_linkedin_app'">
                    <div class="faCodeBox-input-label">
                      {{ $t("FaCodeInputLabel") }}
                    </div>
                    <!-- <div class="faCodeBox-inputs">
                    <input
                      v-for="i in 6"
                      :key="i"
                      v-model="faCode[i - 1]"
                      :ref="'faCodeInput' + (i - 1)"
                      maxlength="1"
                      class="faCodeBox-input"
                      type="text"
                      pattern="[0-9]*"
                      @input="onFaCodeInput(i - 1, $event)"
                      @keydown="onFaCodeKeydown(i - 1, $event)"
                      @paste="onFaCodePaste($event)"
                    />
                  </div> -->
                    <a-form-item :class="[lang]">
                      <a-input size="large" class="process-input" :maxLength="maxLength" autocomplete="off" v-decorator="[
                        'fa_code',
                        {
                          trim: true,
                          rules: [
                            {
                              required: true,
                              validator: function (rule, value, callback) {
                                if (!value || !value.trim('')) {
                                  callback($t('inputCode'));
                                  return;
                                }
                                callback();
                              },
                            },
                          ],
                        },
                      ]" :placeholder="$t('inputCode')" />
                    </a-form-item>
                  </template>

                  <a-modal v-model="faPreviewVisible" :footer="null" :centered="true" :maskClosable="true"
                    :width="faPreviewImg === faChannelImgs.sms ? '520px' : '720px'"
                    wrapClassName="faCodeBox-preview-modal">
                    <img :src="faPreviewImg" alt="" style="width: 100%; border-radius: 6px" />
                  </a-modal>
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </template>
        <!--第一次创建link账户绑定-->
        <template v-if="$route.query.linkedin_id == 'new' && firstReg && !isClickNext">
          <!-- <div class="subTitle">{{ $t("bindLinkAcc") }}</div> -->
          <a-form-item :class="[lang]" :label="$t('LinkedinAccountLabel')">
            <div>
              <a-input style="height: 40px" size="large" class="input" @change="changeHandler1" autocomplete="off"
                :disabled="inputDisabled" v-decorator="[
                  'linkedin_email',
                  {
                    trim: true,
                    rules: [
                      {
                        required: true,
                        validator: function (rule, value, callback) {
                          let reg =
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                          if (!value || !value.trim('') || !reg.test(value)) {
                            callback($t('rightAccount'));
                            return;
                          }
                          callback();
                        },
                      },
                    ],
                  },
                ]" :placeholder="$t('LinkedinEmailPlaceholder')"><svg-icon iconClass="email"
                  slot="prefix"></svg-icon></a-input>
            </div>
          </a-form-item>
          <a-form-item :class="[lang]" :label="$t('PasswordLabel')">
            <a-input-password style="height: 40px" size="large" class="input" type="linkedin_password"
              oninput="value=value.trim()" onchange="value=value.trim()" @change="changePassword" autocomplete="off"
              :disabled="inputDisabled" v-decorator="[
                'linkedin_password',
                {
                  trim: true,
                  rules: [
                    {
                      required: true,
                      message: $t('inputPwd'),
                    },
                  ],
                },
              ]" :placeholder="$t('PasswordPlaceholder')">
              <svg-icon iconClass="lock" slot="prefix"></svg-icon>
            </a-input-password>
            <div class="input-tip" v-show="showTipsInfo">
              <span class="input-tip-icon">💡</span>
              <span class="input-tip-text" v-html="$t('PasswordTipText')">
              </span>
            </div>
          </a-form-item>
          <a-form-item :class="[lang]">
            <template slot="label">
              <span class="tz-label">
                <span>{{ $t("TimeZoneLabel") }}</span>
                <span class="tz-tag"> {{ $t("TimeZoneTag") }}</span>
              </span>
            </template>
            <div class="wrap-select">
              <svg-icon iconClass="timezone" class="prefix"></svg-icon>
              <a-select size="large" class="input process-select" v-decorator="[
                'timezone_config_id',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('selectTimezone'),
                    },
                  ],
                },
              ]" :placeholder="$t('timeZone')">
                <a-select-option :class="[lang]" v-for="(item, index) in TimeZoneList" :key="index" :value="item.id">
                  {{ item.show_name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="input-tip" v-show="showTipsInfo">
              <span class="input-tip-icon">💡</span>
              <span class="input-tip-text" v-html="$t('TimeZoneTipText')">
              </span>
            </div>
          </a-form-item>

          <a-form-item :class="[lang]">
            <template slot="label">
              <span class="tz-label">
                <span>{{ $t("ProxyRegionLabel") }}</span>
                <span class="tz-tag"> {{ $t("ProxyRegionTag") }}</span>
              </span>
            </template>
            <div class="wrap-select">
              <svg-icon iconClass="global" class="prefix"></svg-icon>
              <a-select size="large" class="input process-select" :filter-option="filterOption" showSearch v-decorator="[
                'country_config_id',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('selectRegion'),
                    },
                  ],
                },
              ]" :placeholder="$t('ProxyRegionPlaceholder')">
                <a-select-option :class="[lang]" v-for="(item, index) in locationList" :key="index" :value="item.id">
                  {{ item.show_name }}
                </a-select-option>
              </a-select>
              <div class="input-tip" v-show="showTipsInfo">
                <span class="input-tip-icon">💡</span>
                <span class="input-tip-text" v-html="$t('ProxyRegionTipText')">
                </span>
              </div>
            </div>
          </a-form-item>

          <a-form-item :class="[lang]">
            <template slot="label">
              <span class="tz-label">
                <span>{{ $t("WorkingHoursLabel") }}</span>
                <span class="tz-tag"> {{ $t("WorkingHoursTag") }}</span>
              </span>
            </template>
            <div class="wrap-select">
              <a-icon type="schedule" style="color: #0e756a" class="prefix" />
              <a-select size="large" class="input process-select" v-decorator="[
                'working_time',
                {
                  initialValue: 0,
                  rules: [
                    {
                      required: true,
                      message: $t('selectRegion'),
                    },
                  ],
                },
              ]" :placeholder="$t('WorkingHoursPlaceholder')">
                <a-select-option :class="[lang]" :value="0">
                  {{ $t("AlwaysOn") }}
                </a-select-option>
                <a-select-option :class="[lang]" :value="1">
                  {{ $t("BusinessHoursMS") }}
                </a-select-option>
                <a-select-option :class="[lang]" :value="2">
                  {{ $t("BusinessHoursMF") }}
                </a-select-option>
              </a-select>
              <div class="input-tip" v-show="showTipsInfo">
                <span class="input-tip-icon">💡</span>
                <span class="input-tip-text" v-html="$t('WorkingHoursTipText')">
                </span>
              </div>
            </div>
          </a-form-item>
          <div class="faTips">
            <span class="faTips-icon">ℹ️</span>
            <span class="faTips-text" v-html="$t('FaTipsText')">
            </span>
          </div>
          <!-- <div
            :class="[lang]"
            style="color: red; padding-bottom: 4px; font-size: 12px"
          >
            *1.{{ $t("workTimeDes") }}
          </div>
          <div
            :class="[lang]"
            style="color: red; padding-bottom: 4px; font-size: 12px"
          >
            *2.<span v-html="$t('verifyyourLinkedIn')"></span>
          </div>
          <div
            :class="[lang]"
            style="color: red; padding-bottom: 16px; font-size: 12px"
          >
            *3.<span v-html="$t('Avoidswitchingaccounts')"></span>
          </div> -->
        </template>
        <template v-if="$route.query.linkedin_id == 'new' && firstReg && !isClickNext">
          <a-form-item :style="{ 'text-align': lang == 'AR' ? 'right' : 'left' }">
            <a-button :class="[lang]" size="large" type="primary" :loading="loading" @click="formNextHandler">{{
              $t("NextStep") }}</a-button>
          </a-form-item>
        </template>

        <div v-if="
          detailObj.linkedin_id ||
          linkList.length > 0 ||
          loginLinkInfo.linkedin_id
        ">
          <CampaginsControl :showTipsInfo="showTipsInfo" @handleLimitChange="handleLimitChange" :dailyLimit="dailyLimit"
            :campaignsCount="campaignsCount" @allocationChange="allocationChange" :allocationMode="allocationMode"
            :isLinked="false" :isLtd="is_ltd">
          </CampaginsControl>
        </div>

        <a-form-item style="margin-top: 30px" :style="{ 'text-align': lang == 'AR' ? 'right' : 'left' }">
          <a-button v-if="detailObj.linkedin_id || new_linkedin_id || !firstReg" size="large" type="primary"
            :class="[lang]" @click="nextHandler" :loading="nextBtnLoading">{{ $t("NextStep") }}</a-button>
          <a-button v-if="
            processing &&
            (processStep.step1 == 1 ||
              processStep.step2 == 1 ||
              processStep.step3 == 1) &&
            firstReg &&
            !$route.query.edit
          " size="large" type="primary" :class="[lang]" @click="saveHandler">{{ $t("ContinueConnect") }}</a-button>
        </a-form-item>
      </a-form>
      <!-- <img :class="lang" src="@/assets/img/person.png" alt="" /> -->
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import CampaginsControl from "@/components/campaginsControl/index.vue";
export default {
  components: {
    CampaginsControl,
  },
  data() {
    let that = this;
    return {
      maxLength: 6,
      //领英登录后返回来的数据
      linkLoginInfo: {},
      safeCardExpanded: true,
      loginLinkInfo: {},
      dailyLimit: 25,
      campaignsCount: 3,
      allocationMode: 1,
      is_ltd: true,
      isClickNext: false,
      processing: false,
      loading: false,
      //保存缓存数据
      saveLocalObj: {
        processing: false,
        formData: {},
        processStep: {},
      },
      // 通过获取linkList 判断是不是第一次
      firstReg: false,
      switchVal: true,
      // 已链接的
      // linkList: [],
      new_linkedin_id: null,
      showStep3: false,
      campName: "",
      formData: {},
      form: this.$form.createForm(this, { name: "dynamic_rule" }),
      step: 1,
      tempLinkId: null,
      Pleaseenterthecampaignname: that.$t("Pleaseenterthecampaignname"),
      processStep: {
        step1: 0,
        step2: 0,
        step3: 0,
      },
      visiable: false,
      toPath: null,
      nextBtnLoading: false,
      faCode: ["", "", "", "", "", ""],
      // 验证渠道示意图（对应 img 目录）
      faChannelImgs: {
        app: require("./img/1.png"),
        email: require("./img/2.png"),
        sms: require("./img/3.png"),
        auth: require("./img/4.png"),
      },
      faPreviewVisible: false,
      faPreviewImg: "",
    };
  },
  props: ["detailObj", "linkList", "loaded", "showTipsInfo"],
  computed: {
    ...mapState("setting", ["layout", "theme", "weekMode", "lang"]),
    default_link_id() {
      if (this.detailObj.linkedin_id) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.new_linkedin_id = this.detailObj.linkedin_id;
        return this.detailObj.linkedin_id;
      } else if (this.linkList && this.linkList.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.new_linkedin_id = this.linkList[0].linkedin_id;
        return this.linkList[0].linkedin_id;
      } else {
        return null;
      }
    },
    fromType() {
      if (this.$route.path.indexOf("/hr/recruiter") > -1) {
        return "hr";
      }
      return "sales";
    },
    locaStep1TemDataName() {
      if (this.$route.path.indexOf("/hr/recruiter") > -1) {
        return "step1TemDataHr";
      }
      return "step1TemData";
    },
    // 输入框禁用
    inputDisabled() {
      if (this.userGuide && this.$route.query.linkedin_id == "new") {
        if (
          (this.userGuide.sales_progress == 1 &&
            this.$route.path.indexOf("/sales/salesReps") > -1) ||
          (this.userGuide.hr_progress == 1 &&
            this.$route.path.indexOf("/hr/recruiter") > -1)
        ) {
          return true;
        }
      }
      return false;
    },
  },
  created() {
    this.getLinkList();
    this.getLocationList();
    this.getTimeZone();
    // this.showStep1Popover();
  },
  i18n: require("../capaingni18n"),
  watch: {
    lang(val) {
      console.log("lange", val);
      this.getLocationList();
      this.getTimeZone();
      //   this.Pleaseenterthecampaignname = this.$t("Pleaseenterthecampaignname");
      this.form.validateFields(
        {
          force: true,
        },
        (err, values) => {
          console.log(err, values);
        },
      );
      this.$refs["campaign_name"].blur();
    },
    detailObj() {
      if (this.detailObj.linkedin_id) {
        let { is_ltd, allocation_mode, running_campaign_count, request_limit } =
          this.detailObj;
        this.is_ltd = is_ltd;
        this.allocationMode = allocation_mode;
        this.campaignsCount = running_campaign_count;
        this.dailyLimit = request_limit;
      }
    },
    linkList() {
      this.getLinkList();
    },
  },
  methods: {
    ...mapMutations("setting", ["setDevice"]),
    // 查看验证渠道大图
    viewLargerImg(img) {
      this.faPreviewImg = img;
      this.faPreviewVisible = true;
    },
    handleLimitChange(value) {
      // console.log(value);

      this.dailyLimit = value;
    },
    allocationChange(val) {
      this.allocationMode = val;
    },
    getLinkList() {
      if (this.detailObj.linkedin_id) {
        let { is_ltd, allocation_mode, running_campaign_count, request_limit } =
          this.selectedObj || {};
        this.is_ltd = is_ltd;
        this.allocationMode = allocation_mode;
        this.campaignsCount = running_campaign_count;

        this.dailyLimit = request_limit;
      }

      if (this.linkList.length > 0) {
        this.getInitVale();
        this.firstReg = false;
        return;
      } else {
        this.firstReg = true;
        let temData = localStorage.getItem(this.locaStep1TemDataName);
        if (temData) {
          this.isClickNext = true;
          let { step, processing, processStep, formData, tempLinkId } =
            JSON.parse(temData);
          let { step1, step2, step3 } = processStep;
          console.log(temData, step1, step2, step3);

          if (step1 == 2) {
            processStep.step1 = 1;
          }
          if (step2 == 2) {
            processStep.step2 = 1;
          }
          if (step3 == 2) {
            processStep.step3 = 1;
          }

          this.step = step;
          this.processing = processing;
          this.processStep = processStep;
          this.formData = formData;
          this.tempLinkId = tempLinkId;
          this.campName = formData.campaign_name;
        }
      }
      // this.$axios(
      //   "/linkedin/list",
      //   { campaign_type: 1, status: 1 },
      //   "post"
      // ).then((res) => {
      //   if (res.code == 200) {
      //     if (res.data && res.data.length > 0) {
      //       this.linkList = res.data;
      //       this.firstReg = false;
      //     } else {
      //       this.firstReg = true;
      //       let temData = localStorage.getItem("step1TemData");
      //       if (temData) {
      //         this.isClickNext = true;
      //         let { step, processing, processStep, formData, tempLinkId } =
      //           JSON.parse(temData);
      //         this.step = step;
      //         this.processing = processing;
      //         this.processStep = processStep;
      //         this.formData = formData;
      //         this.tempLinkId = tempLinkId;
      //         this.campName = formData.campaign_name;
      //       }
      //     }
      //   }
      // });
    },
    getcountry(id) {
      let name = "";
      this.locationList.some((item) => {
        if (item.id == id) {
          name = item.show_name;
          return true;
        } else {
          return false;
        }
      });
      return name;
    },
    getTimez(id) {
      let name = "";
      this.TimeZoneList.some((item) => {
        if (item.id == id) {
          name = item.show_name;
          return true;
        } else {
          return false;
        }
      });
      return name;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getInitVale() {
      if (this.linkList.length > 0) {
        this.linkList.find((item) => {
          if (item.linkedin_id === this.default_link_id) {
            const {
              is_ltd,
              allocation_mode,
              running_campaign_count,
              request_limit,
            } = item;
            this.is_ltd = is_ltd ? true : false;
            this.allocationMode = allocation_mode;
            this.campaignsCount = running_campaign_count;

            this.dailyLimit = request_limit;
          }
        });
      }
    },
    selectedRadio(event) {
      this.new_linkedin_id = event.target.value;

      this.linkList.find((item) => {
        if (item.linkedin_id === event.target.value) {
          const {
            is_ltd,
            allocation_mode,
            running_campaign_count,
            request_limit,
          } = item;
          this.is_ltd = is_ltd ? true : false;
          this.allocationMode = allocation_mode;
          this.campaignsCount = running_campaign_count;

          this.dailyLimit = request_limit;
        }
      });
    },
    changeHandler1() {
      this.new_linkedin_id = null;
    },
    onFaCodeInput(index, e) {
      const val = (e.target.value || "").replace(/\D/g, "");
      this.$set(this.faCode, index, val.slice(-1));
      if (val && index < 5) {
        const next = this.$refs["faCodeInput" + (index + 1)];
        if (next && next[0]) next[0].focus();
      }
    },
    onFaCodeKeydown(index, e) {
      if (e.key === "Backspace" && !this.faCode[index] && index > 0) {
        const prev = this.$refs["faCodeInput" + (index - 1)];
        if (prev && prev[0]) prev[0].focus();
      } else if (e.key === "ArrowLeft" && index > 0) {
        const prev = this.$refs["faCodeInput" + (index - 1)];
        if (prev && prev[0]) prev[0].focus();
      } else if (e.key === "ArrowRight" && index < 5) {
        const next = this.$refs["faCodeInput" + (index + 1)];
        if (next && next[0]) next[0].focus();
      }
    },
    onFaCodePaste(e) {
      const text = (e.clipboardData.getData("text") || "")
        .replace(/\D/g, "")
        .slice(0, 6);
      if (!text) return;
      e.preventDefault();
      const chars = text.split("");
      for (let i = 0; i < 6; i++) {
        this.$set(this.faCode, i, chars[i] || "");
      }
      const focusIdx = Math.min(chars.length, 5);
      const target = this.$refs["faCodeInput" + focusIdx];
      if (target && target[0]) target[0].focus();
    },
    setLocalData() {
      let formData = { ...this.formData };
      delete formData.campaign_name;
      this.saveLocalObj = {
        processing: this.processing,
        formData: formData,
        processStep: this.processStep,
        tempLinkId: this.tempLinkId,
        step: this.step,
      };
      localStorage.setItem(
        this.locaStep1TemDataName,
        JSON.stringify(this.saveLocalObj),
      );
    },
    // 新用户昨时保存
    formNextHandler() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // this.isClickNext = true;
          // this.processing = true;
          console.log("setp---", this.step);
          this.formData = values;
          this.saveHandler();
        }
      });
    },
    step1(values) {
      return new Promise((resolve) => {
        this.processStep.step1 = 2;
        // let { linkedin_email } = values;
        this.loading = true;
        this.$axios(
          "/linkedin/save_new_linkedin",
          {
            ...this.formData,
            ...values,
            // email: linkedin_email,
            proxy_manually: 1,
            campaign_type: this.fromType === "hr" ? 2 : 1,
          },
          "post",
        )
          .then((res) => {
            this.loading = false;
            if (res.code == 200) {
              this.isClickNext = true;
              this.processing = true;
              this.processStep.step1 = 3;
              this.tempLinkId = res.data.new_linkedin_id;
              this.processStep.step2 = 1;
              this.getUserInfo();
              this.setLocalData();

              resolve(1);
            } else {
              this.processStep.step1 = 1;
              this.loading = false;
              // this.$message.error(res.msg);
              this.step = 1;
              resolve(2);
            }
          })
          .catch((e) => {
            console.log(e);
            this.loading = false;
          });
      });
    },
    step2(values) {
      return new Promise((resolve) => {
        this.step = 2;
        this.processStep.step2 = 2;
        // if (this.tempLinkId && this.processStep.step2 == 2) {
        //   this.$axios(
        //     "/linkedin/update_linkedin",
        //     {
        //       ...values,
        //       linkedin_id: parseInt(this.tempLinkId),
        //       proxy_manually: 1,
        //     },
        //     "post"
        //   )
        //     .then((res) => {
        //       if (res.code == 200) {
        //         //
        //       } else {
        //         this.loading = false;
        //       }
        //     })
        //     .catch((e) => {
        //       console.log(e);
        //       this.loading = false;
        //     });
        // }
        this.$axios(
          "/linkedin/linkedin_login",
          {
            linkedin_id: parseInt(this.tempLinkId),
            ...this.formData,
            ...values,
           // "mock_login_result": "email"
          },
          "post",
        )
          .then((res2) => {
            if (res2.code == 200) {
              if (res2.data.action == 'continue') {
                this.processStep.step2 = 3;
                this.new_linkedin_id = this.tempLinkId;
                this.$message.success(res2.msg);
                this.processStep.step3 = 2;
                this.loading = false;
                localStorage.removeItem(this.locaStep1TemDataName);
                this.getUserInfo();
                // 模拟第三步成功
                setTimeout(() => {
                  this.processStep.step3 = 3;
                  this.processing = false;
                  this.loginLinkInfo = res2.data;
                  this.allocationMode = res2.data.allocation_mode;
                  this.dailyLimit = res2.data.request_limit;
                  this.is_ltd = res2.data.is_ltd ? true : false;
                  setTimeout(() => {
                    this.firstReg = true;
                  }, 200);
                }, 2000);
              } else if (res2.data.action == 'input_verification_code' || res2.data.action == 'confirm_in_linkedin_app') {
                this.linkLoginInfo = res2.data;
                this.step = 3;
                this.processStep.step2 = 3;
                // 模拟第三步失败
                // this.$message.error(res2.msg);
                this.processStep.step3 = 1;
                this.loading = false;
                this.setLocalData();
              }

            } else {
              this.step = 2;
              // 登录失败
              this.processStep.step2 = 1;
              this.loading = false;
              this.setLocalData();
            }
            resolve();
          })
          .catch((e) => {
            console.log(e);
            this.loading = false;
            this.processStep.step2 = 1;
            this.setLocalData();
          });
      });
    },
    step3(values) {
      return new Promise((resolve) => {
        let { fa_code } = values;
        const code = this.linkLoginInfo.action === "confirm_in_linkedin_app"
          ? "123456"
          : String(fa_code || "").trim();
        this.processStep.step3 = 2;
        this.$axios(
          "/linkedin/linkedin_input",
          {
            fa_code: code,
            linkedin_id: this.tempLinkId,
          },
          "post",
        )
          .then((res) => {
            this.loading = false;

            if (res.code == 200) {
              this.$message.success(res.msg);
              this.processStep.step3 = 3;
              this.new_linkedin_id = this.tempLinkId;
              this.processing = false;
              this.loginLinkInfo = res.data;
              this.allocationMode = res.data.allocation_mode;
              this.dailyLimit = res.data.request_limit;
              this.is_ltd = res.data.is_ltd ? true : false;
              localStorage.removeItem(this.locaStep1TemDataName);
              this.getUserInfo();
              setTimeout(() => {
                this.firstReg = true;
              }, 200);
            } else {
              // this.$message.error(res.msg);
              this.processStep.step3 = 1;
              this.setLocalData();
            }
            resolve();
          })
          .catch((e) => {
            console.log(e);
            this.loading = false;
            this.processStep.step3 = 1;
            this.setLocalData();
          });
      });
    },
    saveHandler() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.loading) {
            return;
          }
          this.loading = true;
          this.formData = {
            ...this.formData,
            ...values,
          };
          console.log(
            "---saveHandler this-formdatq------",
            values,
            this.formData,
          );

          if (
            this.processing &&
            (this.processStep.step1 == 1 ||
              this.processStep.step2 == 1 ||
              this.processStep.step3 == 1) &&
            this.firstReg &&
            !this.$route.query.edit
          ) {
            this.writeLog(
              "create_campaign",
              this.fromType == "sales" ? "sales" : "recruiter",
              "click_continue_connect",
            );
          }
          if (this.step == 1) {
            this.writeLog(
              "create_campaign",
              this.fromType == "sales" ? "sales" : "recruiter",
              "click_linkedin_connect",
            );
            this.step1(values).then((res) => {
              if (res == 1) {
                this.step = 2;
                this.setLocalData();
                this.step2(values);
              }
            });
          }
          if (this.step == 2) {
            this.isClickNext = true;
            this.processing = true;
            this.step2(values).then((res) => {
              console.log(res);
            });
          }
          if (this.step == 3) {
            this.isClickNext = true;
            this.processing = true;
            this.step3(values);
          }
        }
      });
    },
    nextHandler() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.nextBtnLoading = true;
          let linkedin_id =
            this.$route.query.edit == "1" || this.$route.query.edit == "2"
              ? this.detailObj.linkedin_id
              : this.new_linkedin_id;
          this.writeLog(
            "create_campaign",
            this.fromType == "sales" ? "sales" : "recruiter",
            "campaign_step1_next",
          );
          if (this.$route.query.linkedin_id == "new") {
            // 校验是否为免费账号，只能创建一个

            this.$axios(
              "/public/can_create",
              {
                linkedin_id,
              },
              "post",
            )
              .then((res) => {
                if (res.code == 200) {
                  if (res.data && res.data.data) {
                    this.$axios(
                      "/linkedin/update_linkedin_limits",
                      {
                        linkedin_id: linkedin_id,
                        request_limit: this.dailyLimit,
                        allocation_mode: this.allocationMode,
                      },
                      "post",
                    ).then((res) => {
                      this.nextBtnLoading = false;
                      if (res.code == 200) {
                        // this.linkedin_info.request_limit = this.dailyLimit;
                        //this.$message.success("更新成功");
                        this.$emit("callback", {
                          ...values,
                          linkedin_id,
                        });
                      }
                    });
                  } else {
                    this.nextBtnLoading = false;
                    this.$message.error(this.$t("noFirstCampaignTip"));
                  }
                  return;
                }
                this.$message.error(res.msg);
              })
              .catch(() => {
                this.nextBtnLoading = false;
              });
          } else {
            this.$axios(
              "/linkedin/update_linkedin_limits",
              {
                linkedin_id: linkedin_id,
                request_limit: this.dailyLimit,
                allocation_mode: this.allocationMode,
              },
              "post",
            ).then((res) => {
              this.nextBtnLoading = false;
              if (res.code == 200) {
                // this.linkedin_info.request_limit = this.dailyLimit;
                //this.$message.success("更新成功");
                this.$emit("callback", {
                  ...values,
                  linkedin_id,
                });
              }
            });
          }
        }
      });
    },
    // 获取当前是否打开第二步的下拉框
    showStep1Popover() {
      // 添加校验是否是第一次打开，如果是第一次打开，则弹出
      let iteMName =
        this.fromType == "hr"
          ? "HRBindLinkedInAccPopover"
          : "BindLinkedInAccPopover";
      const BindLinkedInAccPopover = localStorage.getItem(iteMName);
      console.log(iteMName, BindLinkedInAccPopover);
      if (BindLinkedInAccPopover) {
        this.visiable = false;
      } else {
        this.visiable = true;
        localStorage.setItem(iteMName, true);
      }
    },
    // hover弹框点击按钮进入文档详情页
    goLink() {
      window.open(
        "https://leadgeneration.tawk.help/article/linkedin-usage-restrictions-and-settings",
      );
    },
    // 校验任务名称是否合法
    async isCampaignNameLegal(val) {
      let resInfo = {};
      let url =
        this.fromType == "hr" ? "/recruiter/check_name" : "/sales/check_name";
      let params = {};
      if (this.$route.query.edit == 2 || this.$route.query.edit == 3) {
        params.campaign_id = parseInt(this.$route.query.campaign_id);
      }
      await this.$axios(
        url,
        {
          campaign_name: val,
          ...params,
          // linkedin_id: this.$route.query.edit == "1"
          //       ? this.detailObj.linkedin_id
          //       : this.new_linkedin_id
        },
        "post",
      ).then((res) => {
        resInfo = res && res.data;
      });
      return resInfo;
    },
    changePassword(e) {
      this.changeHandler1();
      let value = e.target.value.trim();
      this.$nextTick(() => {
        this.form.setFieldsValue({
          linkedin_password: value,
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
@primary: #0e756a;
@primary-dark: #0a5d54;
@hint-bg: #f6ffed;
@hint-border: #b7eb8f;
@hint-soft: #f3fbf8;
@title-color: #1f1f1f;
@muted-color: rgba(0, 0, 0, 0.45);
@muted-strong: rgba(0, 0, 0, 0.65);
@muted-soft: rgba(0, 0, 0, 0.55);
@border-soft: #d9d9d9;
@bg-soft: #fafafa;
@linkedin-blue: #0a66c2;
@chart-purple: #722ed1;
@target-orange: #fa8c16;
@import url(../style/process.less);

// .step-hint-bar {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   flex-wrap: wrap;
//   gap: 12px;
//   padding: 12px 18px;
//   margin-bottom: 28px;
//   background: @hint-soft;
//   border-radius: 8px;

//   .step-hint-left {
//     display: flex;
//     align-items: center;
//     gap: 12px;

//     .hand-icon {
//       font-size: 22px;
//     }

//     .step-hint-text {
//       display: flex;
//       flex-direction: column;
//       gap: 2px;

//       .step-hint-title {
//         font-size: 14px;
//         font-weight: 600;
//         color: @title-color;
//       }

//       .step-hint-desc {
//         font-size: 12px;
//         color: @muted-strong;
//       }
//     }
//   }

//   .pro-hint-btn {
//     font-size: 13px;
//     color: @title-color;
//     background: #fff;
//     border-color: @border-soft;
//     padding: 5px 11px;
//     cursor: pointer;
//     height: auto;
//   }

//   .minimized-btn {
//     background: #0e756a;
//     border-color: #0e756a;
//     color: #fff;
//   }
// }

.safe-card {
  overflow: hidden;
  margin-bottom: 16px;
  border: 1px solid #d3ebe3;
  background: linear-gradient(180deg, #f3fbf8, #fff);
  border-radius: 8px;

  .safe-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    font-size: 15px;
    font-weight: 600;
    color: @title-color;
    cursor: pointer;

    .shield-icon {
      margin-right: 6px;
    }
  }

  .safe-card-body {
    padding: 0 16px 16px;

    .safe-intro {
      margin-bottom: 14px;
      font-size: 13px;
      line-height: 1.6;
      color: @muted-strong;
    }

    .safe-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px 24px;
      margin-bottom: 12px;

      @media (max-width: 600px) {
        grid-template-columns: 1fr;
      }
    }

    .safe-item {
      display: flex;
      gap: 10px;
      align-items: flex-start;

      .safe-item-icon {
        flex-shrink: 0;
        font-size: 18px;
        line-height: 1.4;
      }

      .safe-item-text {
        .safe-item-title {
          margin-bottom: 2px;
          font-size: 14px;
          font-weight: 600;
          color: @title-color;
        }

        .safe-item-desc {
          font-size: 12px;
          line-height: 1.4;
          color: @muted-soft;
        }
      }
    }

    .learn-more {
      font-size: 13px;
      font-weight: 600;
      color: @primary;
    }
  }
}

.box {
  background: #fff;
  padding: 38px 30px;
  min-height: 700px;

  .tit {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 20px;
    color: #000000;
    margin-bottom: 30px;

    .tit-icon {
      margin-right: 10px;
    }
  }

  .AR {
    .tit-icon {
      margin-right: 0;
      margin-left: 10px;
    }
  }

  .subTitle {
    font-family: Arial, Arial;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 21px;
  }

  .m50 {
    margin-top: 50px;
  }

  .searchSelected {
    display: flex;

    li {
      cursor: pointer;
      width: 414px;
      height: 170px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dfdfdf;
      margin-right: 30px;
      color: #666666;
      font-weight: bold;
      text-align: center;

      @media screen and (max-width: 1680px) {
        width: 314px;
      }

      .stit {
        font-size: 20px;
        margin-top: 33px;
      }

      .cont {
        margin-top: 35px;
        font-size: 16px;
        line-height: 24px;
      }

      position: relative;

      .checkbox {
        position: absolute;
        right: 8px;
        top: 8px;
        display: none;
      }
    }

    .selected {
      background: transparent;
      box-shadow: 0px 0px 14px 1px rgba(14, 117, 106, 0.14);
      border-radius: 4px 4px 4px 4px;
      border: 2px solid #0e756a;

      .checkbox {
        display: block;
      }
    }
  }

  .wrap-form {
    .form {
      // width: 500px;
      position: relative;
      z-index: 1;

      /deep/.ant-input {
        background: transparent;
      }
    }

    position: relative;

    // img {
    //   position: absolute;

    //   width: 295px;
    //   height: 228px;
    //   top: 30px;
    //   right: 155px;
    // }

    img.AR {
      right: inherit;
    }

    @media screen and (max-width: 1680px) {
      // img {
      //   width: 295px;
      //   height: 228px;
      //   top: 30px;
      //   right: 40px;
      // }

      // img.AR {
      //   right: inherit;
      // }
    }
  }

  .switchbox {
    margin-bottom: 30px;

    .switch {
      margin-right: 11px;
    }
  }

  .connect {
    border: #0e756a solid 1px;
    color: #0e756a;
  }

  .m120 {
    margin-right: 120px;
  }

  /deep/.ant-form-item {
    margin-bottom: 20px;
  }

  // /deep/.ant-input::placeholder {
  //   color: #999999 !important;
  //   background: #dfdfdf;
  // }
  // /deep/.ant-input:placeholder-shown {
  //   text-overflow: ellipsis;
  //   background: #dfdfdf;
  // }
  .input {
    // width: 500px;
  }

  .wrap-link-list {
    li {
      background: transparent;
    }
  }

  .showInfo {
    background: transparent;
  }
}

.popbox {
  width: 480px;

  .main-tit {
    font-weight: bold;
    font-size: 16px;
    color: #0e756a;
    margin-bottom: 0;
    margin-top: 17px;
  }

  .ptit {
    margin-top: 17px;
    font-size: 14px;
    color: #000000;
    user-select: none;

    .rtl {
      margin-right: 0px;
      margin-left: 7px;
    }

    .txt-red {
      color: #ff4d4f;
    }
  }

  .btn-box {
    margin-top: 34px;
    color: #000;

    .btn-txt {
      color: #0e756a;
      cursor: pointer;
    }
  }

  // Time Zone label with green tag
}

// Password tip line
/deep/.input-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.6;

  .input-tip-icon {
    flex-shrink: 0;
    font-size: 14px;
  }

  .input-tip-text {
    flex: 1;

    .eye {
      font-size: 13px;
      margin: 0 2px;
    }

    .input-tip-bold {
      font-weight: 600;
      color: #1f1f1f;
      margin-right: 4px;
    }

    .input-tip-link {
      color: #0e756a;
      font-weight: 500;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

// 2FA tip card
/deep/.faTips {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 16px 0;
  padding: 14px 18px;
  font-size: 14px;
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.65);
  background: #f6faff;
  border: 1px dashed #b8d4ff;
  border-radius: 8px;

  .faTips-icon {
    flex-shrink: 0;
    font-size: 16px;
    line-height: 1.5;
  }

  .faTips-text {
    flex: 1;

    .faTips-bold {
      font-weight: 600;
      color: #1f1f1f;
    }
  }
}

// 2FA verification code box
/deep/.faCodeBox {
  margin: 16px 0 24px;
  padding: 22px 24px 28px;
  background: #f6faff;
  border: 1px solid #d9e7f7;
  border-radius: 12px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);

  .faCodeBox-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #1f1f1f;
    margin-bottom: 12px;

    .faCodeBox-title-icon {
      font-size: 18px;
    }
  }

  .faCodeBox-desc {
    margin: 0 0 18px;
    line-height: 1.6;

    .faCodeBox-bold {
      font-weight: 600;
      color: #1f1f1f;
    }
  }

  .faCodeBox-channels {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin-bottom: 24px;

    @media (max-width: 640px) {
      grid-template-columns: 1fr;
    }
  }

  .faCodeBox-channel {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 14px 16px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    transition: border-color 0.2s, box-shadow 0.2s;

    &.primary {
      background: #f0fbf6;
      border-color: #b7e3cf;
      border-left: 3px solid #0e756a;
    }

    .faCodeBox-channel-head {
      display: flex;
      align-items: flex-start;
      gap: 10px;
    }

    .faCodeBox-channel-icon {
      flex-shrink: 0;
      font-size: 22px;
      line-height: 1.2;
    }

    .faCodeBox-channel-text {
      flex: 1;
      min-width: 0;
    }

    .faCodeBox-channel-title {
      font-size: 14px;
      font-weight: 600;
      color: #1f1f1f;
      margin-bottom: 4px;
    }

    .faCodeBox-channel-desc {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.55);
      line-height: 1.5;
    }

    .faCodeBox-channel-shot {
      height: 140px;
      overflow: hidden;
      background: #f3f4f6;
      border: 1px solid #eef0f2;
      border-radius: 6px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        display: block;
        width: auto;
        height: 140px;
        object-fit: cover;
        object-position: top;
      }
    }

    .faCodeBox-channel-view {
      margin-top: auto;
      font-size: 12px;
      color: #0e756a;
      line-height: 1.4;
      cursor: pointer;
      text-decoration: none;
      text-align: right;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .faCodeBox-input-label {
    font-size: 14px;
    font-weight: 500;
    color: #1f1f1f;
    margin-bottom: 10px;
  }

  .faCodeBox-inputs {
    display: flex;
    gap: 10px;
  }

  .faCodeBox-input {
    width: 44px;
    height: 50px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: #1f1f1f;
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus {
      border-color: #0e756a;
      box-shadow: 0 0 0 2px rgba(14, 117, 106, 0.15);
    }
  }
}
</style>
<style lang="less">
.faCodeBox-preview-modal {
  .ant-modal-body {
    padding: 12px;
  }
}
</style>
